import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./musicRequestEventStyle.css";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import debounce from "lodash.debounce";
import axios from 'axios';
import pLimit from 'p-limit';
import {QRCodeCanvas} from "qrcode.react";

export default function MusicRequestEvent() {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const eventId = searchParams.get("id");
    const eventCode = searchParams.get("code");

    const [musicRequests, setMusicRequests] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [votings, setVotings] = useState([]);

    const [showPopup, setShowPopup] = useState(false);
    const [showSongManagingPopup, setShowSongManagingPopup] = useState(false);
    const [showEventSettingsPopup, setShowEventSettingsPopup] = useState(false);
    const [currentManagingSongId, setCurrentManagingSongId] = useState();

    const [searchStep, setSearchStep] = useState(1);
    const [currentTrackTitle, setCurrentTrackTitle] = useState("");
    const [artists, setArtists] = useState([]);

    const [tidalToken, setTidalToken] = useState("");

    useEffect(() => {
        document.title = "DJ - EMAN"

        getMusicRequests();
        getVotings();
        getTidalToken();

        const role = localStorage.getItem("role");
        if (role === "admin") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

        const intervalId = setInterval(() => {
            getMusicRequests();
            getVotings();
        }, 10000);

        return () => {
            clearInterval(intervalId);
        }
    }, []);

    const [searchTerm, setSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    useEffect(() => {
        const handler = setTimeout(() => {
            fetchSuggestions(searchTerm);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchTerm]);

    const fetchSuggestions = async (term) => {
        if (!term) {
            setSuggestions([]);
            return;
        }
        try {
            const response = await fetch(
                `https://openapi.tidal.com/v2/searchResults/${encodeURIComponent(term)}/relationships/tracks?countryCode=DE&explicitFilter=include,exclude`,
                {
                    headers: {
                        "accept": "application/vnd.api+json",
                        "Authorization": `Bearer ` + tidalToken,
                        "Content-Type": "application/vnd.tidal.v1+json",
                    },
                }
            );
            const data = await response.json();
            const ids = data.data?.filter(item => item.type === 'tracks')?.slice(0, 10)?.map(item => item.id);

            if (!ids || ids.length === 0) {
                setSuggestions([]);
                return;
            }

            const limit = pLimit(2);

            const detailRequests = await fetchTracksByIds(ids);

            const detailResponses = await Promise.all(detailRequests);

            setSuggestions(detailResponses);

            await new Promise(resolve => setTimeout(resolve, 2000));
            const artistsIds = await detailResponses.map(track => {
                return track.relationships?.artists?.data?.[0]?.id || null;
            });
            const artistsResponse = await fetchArtistsByIds(artistsIds);

            setArtists(artistsResponse);
        } catch (error) {
            console.error("Fehler bei der Tidal-Suche: ", error);
            setSuggestions([]);
        }
    };

    async function fetchTracksByIds(ids) {
        const queryParams = new URLSearchParams();
        queryParams.append('countryCode', 'DE');
        ids.forEach(id => queryParams.append('filter[id]', id));

        const url = `https://openapi.tidal.com/v2/tracks?${queryParams.toString()}&include=artists`;

        const res = await axios.get(url, {
            headers: {
                "accept": "application/vnd.api+json",
                "Authorization": `Bearer ` + tidalToken,
                "Content-Type": "application/vnd.tidal.v1+json",
            }
        });

        return res.data.data;
    }

    async function fetchArtistsByIds(ids) {
        const queryParams = new URLSearchParams();
        queryParams.append('countryCode', 'DE');
        ids.forEach(id => queryParams.append('filter[id]', id));

        const url = `https://openapi.tidal.com/v2/artists?${queryParams.toString()}`;

        const res = await axios.get(url, {
            headers: {
                "accept": "application/vnd.api+json",
                "Authorization": "Bearer " + tidalToken,
                "Content-Type": "application/vnd.tidal.v1+json",
            }
        });

        return res.data.data;
    }

    const getTidalToken = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/tidal-token", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.text();
                console.log(data)
                setTidalToken(data);
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const getMusicRequests = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/musicrequests?token=" + Cookies.get("token") + "&id=" + searchParams.get("id") + "&code=" + eventCode, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();
                setMusicRequests(data);
            } else if (response.status === 409) {
                navigate("/musicrequesthome");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const getVotings = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/uservotings?token=" + Cookies.get("token") + "&id=" + localStorage.getItem("id") + "&eventId=" + eventId, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();
                setVotings(data);
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function addEvent() {
        if (!showPopup) {
            setShowPopup(true);
        }
    }

    function switchSide(side) {
        navigate(side);
    }

    const handleCreateMusicRequest = async (interpreter) => {
        setShowPopup(false);
        setSearchStep(1);

        const musicRequestData = {
            userId: localStorage.getItem("id"),
            eventId: eventId,
            title: currentTrackTitle,
            interpreter: interpreter,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/addmusicrequest?token=" + Cookies.get("token"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(musicRequestData),
            });

            if (response.ok) {
                window.location.reload();
            } else {
                if (response.status === 406) {
                    Cookies.remove("token");
                    localStorage.removeItem("id");
                    localStorage.removeItem("username");
                    localStorage.removeItem("role");
                    navigate("/login");
                } else if (response.status === 409) {
                    toast.error("Für diesen Titel wurde bereits abgestimmt");
                } else {
                    toast.error("Es ist ein Fehler beim wünschen des Songs aufgetreten");
                }
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }

        setCurrentTrackTitle("");
    }

    const addVoting = async (songId) => {
        const votingData = {
            songId: songId,
            userId: localStorage.getItem("id"),
            eventId: eventId,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/addvoting?token=" + Cookies.get("token"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(votingData),
            });

            if (response.ok) {
                getVotings();
            } else if (response.status === 409) {
                toast.error("Du kannst deinen eigenen Songwunsch nicht endvoten");
            } else {
                toast.error("Es ist ein Fehler beim voten des Songs aufgetreten");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function manageSong(songId) {
        if (isAdmin) {
            if (!showSongManagingPopup) {
                setCurrentManagingSongId(songId);
                setShowSongManagingPopup(true);
            }
        }
    }

    const deleteSong = async () => {
        setShowSongManagingPopup(false);
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/deletemusicrequest?token=" + Cookies.get("token") + "&songId=" + currentManagingSongId, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                getMusicRequests();
                toast.success("Der Song wurde gelöscht");
            } else {
                toast.error("Der Song konnte nicht gelöscht werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const markSong = async (state) => {
        setShowSongManagingPopup(false);
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/markmusicrequest?token=" + Cookies.get("token") + "&songId=" + currentManagingSongId + "&eventId=" + eventId + "&state=" + state, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                getMusicRequests();
            } else {
                toast.error("Der Song konnte nicht als gespielt markiert werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const blockUser = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/blockuserfromsongid?token=" + Cookies.get("token") + "&songId=" + currentManagingSongId, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                toast.success("Der Nutzer wurde gesperrt");
                deleteSong();
            } else {
                toast.error("Der Nutzer konnte nicht gesperrt werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const changeEventState = async (state) => {
        setShowEventSettingsPopup(false);
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/closeevent?token=" + Cookies.get("token") + "&eventId=" + eventId + "&state=" + state, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                if (state === 0 || state === 2) {
                    navigate("/musicrequesthome");
                } else {
                    toast.success("Das Event wurde geöffnet");
                }
            } else {
                toast.error("Der Status des Events konnte nicht geändert werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function closePopup() {
        setShowPopup(false);
        setCurrentTrackTitle("");
        setSearchStep(1);
        setSearchTerm("");
    }

    function closeSongManagingPopup() {
        setShowSongManagingPopup(false);
    }

    function closeEventSettingsPopup() {
        setShowEventSettingsPopup(false);
    }

    function openEventSettingsPopup() {
        if (!showEventSettingsPopup) {
            setShowEventSettingsPopup(true);
        }
    }

    function setNextSearchStep(trackTitle) {
        setCurrentTrackTitle(trackTitle);
        setSearchStep(2);
    }

    const uniqueSuggestions = [...new Map(
        suggestions.map(track => [track.attributes.title, track])
    ).values()];

    return (
        <div className="musicRequestEventContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>Song Voting</h1>
            <img className="backArrow" onClick={() => switchSide("/musicrequesthome")}src="/img/arrowLeft.svg" />
            <div className="chooseButtonContainer">
                <div className="plusContainer" onClick={() => addEvent()}>
                    <img src="/img/plus.svg" />
                    <h3>Song wünschen</h3>
                </div>
                <div className="plusContainer" onClick={() => switchSide(isAdmin ? "/openChats?eventId=" + eventId : "/chat?eventId=" + eventId)}>
                    <img src="/img/chat.svg" />
                    <h3>DJ Nachricht</h3>
                </div>
                {isAdmin && (
                    <div className="plusContainer" onClick={() => openEventSettingsPopup()}>
                        <img src="/img/settings.svg" />
                        <h3>Event Einstellungen</h3>
                    </div>
                )}
            </div>
            {musicRequests.filter(musicRequest => musicRequest.state === 1 || musicRequest.state === 2 || musicRequest.state === 3).map((musicRequest) => (
                <div
                    className={`songContainer
                        ${musicRequest.state === 2 ? "greenState" : ""}
                        ${musicRequest.state === 3 ? "blueState" : ""}
                    `}
                >
                    <div className="votesStatesContainer">
                        <h2>{musicRequest.votings}x</h2>
                        {musicRequest.state === 2 && (
                            <>
                                <img className="rotationAnimation" src="/img/discGreen.svg" />
                                <h2 className="stateTitleGreen">Spielt gerade</h2>
                            </>
                        )}
                        {musicRequest.state === 3 && (
                            <>
                                <img src="/img/hourglassBlue.svg" />
                                <h2 className="stateTitleBlue">Wird demnächst gespielt</h2>
                            </>
                        )}
                    </div>
                    <div className="titleInterpreterContainer">
                        <h3 onClick={() => manageSong(musicRequest.id)}>{musicRequest.title}</h3>
                        <h4 onClick={() => manageSong(musicRequest.id)}>{musicRequest.interpreter}</h4>
                    </div>
                    {!votings.includes(musicRequest.id) && (
                        <img className="thumbsUpImage" onClick={() => addVoting(musicRequest.id)} src="/img/thumbsUp.svg" />
                    )}
                    {votings.includes(musicRequest.id) && (
                        <img className="thumbsUpImage" onClick={() => addVoting(musicRequest.id)} src="/img/thumbsUpOrange.svg" />
                    )}
                </div>
            ))}
            <hr />
            <h2>Bereits gespielt</h2>
            {musicRequests.filter(musicRequest => musicRequest.state === 0).map((musicRequest) => (
                <div className="songContainerArchiv">
                    <h2>{musicRequest.votings}x</h2>
                    <div className="titleInterpreterContainer">
                        <h3 onClick={() => manageSong(musicRequest.id)}>{musicRequest.title}</h3>
                        <h4 onClick={() => manageSong(musicRequest.id)}>{musicRequest.interpreter}</h4>
                    </div>
                </div>
            ))}
            {showPopup && (
                <div className="modalOverlay" onClick={() => closePopup()}>
                    <div id="popup" onClick={(e) => e.stopPropagation()}>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <h1>Wunschkarte</h1>
                            <h2>{searchStep == 1 ? "Suche nach deinem Songtitel" : "Suche nach dem Interpreter deines Songtitels"}</h2>
                            <img className="closeButton" onClick={() => closePopup()} src="/img/xMarkWhite.svg" />
                            <input
                                type="text"
                                placeholder="Songtitel"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                disabled={searchStep !== 1}
                            />
                        </form>
                        <div className="titleContainer">
                            {searchStep === 1 ? (
                                uniqueSuggestions.map((track, index) => (
                                    <div key={track.id} className="trackItem">
                                        <div onClick={() => setNextSearchStep(track.attributes.title)} className="meaningContainer">
                                            <h1>{track.attributes.title}</h1>
                                            <h2>{new Date(track.attributes.createdAt).toLocaleString("de-DE", {day: "2-digit", month: "long", year: "numeric"})}</h2>
                                        </div>
                                        {index !== uniqueSuggestions.length - 1 && (
                                            <div className="titleLine" />
                                        )}
                                    </div>
                                ))
                            ) : (
                                artists.map((artist, index) => (
                                    <div key={artist.id} className="trackItem">
                                        <div onClick={() => handleCreateMusicRequest(artist.attributes.name)} className="meaningContainer">
                                            <h1>{artist.attributes.name}</h1>
                                        </div>
                                        {index !== artists.length - 1 && (
                                            <div className="titleLine" />
                                        )}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            )}
            {showSongManagingPopup && (
                <div id="songManagingPopup">
                    <img className="closeButton" onClick={() => closeSongManagingPopup()} src="/img/xMarkWhite.svg" />
                    <button onClick={() => markSong(0)}>
                        Song wurde gespielt
                    </button>
                    <button className="greenBorder" onClick={() => markSong(2)}>
                        Wird aktuell gespielt
                    </button>
                    <button className="blueBorder" onClick={() => markSong(3)}>
                        Wird demnächst gespielt
                    </button>
                    <button className="greyBorder" onClick={() => markSong(1)}>
                        Auf Warteliste setzen
                    </button>
                    <button className="redBorder" onClick={() => deleteSong()}>
                        Song löschen
                    </button>
                    <button className="redBorder" onClick={() => blockUser()}>
                        Nutzer sperren
                    </button>
                </div>
            )}
            {showEventSettingsPopup && (
                <div id="songManagingPopup">
                    <img className="closeButton" onClick={() => closeEventSettingsPopup()} src="/img/xMarkWhite.svg" />
                    <button onClick={() => changeEventState(0)}>
                        Event schließen
                    </button>
                    <button onClick={() => changeEventState(2)}>
                        Event löschen
                    </button>
                    <button onClick={() => changeEventState(1)}>
                        Event öffnen
                    </button>
                    <div className="qrcodeContainer">
                        <QRCodeCanvas value={`https://djeman.de/musicrequestevent?id=${eventId}&code=${eventCode}`} size={250} />
                    </div>
                </div>
            )}
        </div>
    )
}
